import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/ai/admin/adminAiGenerationQueryKeys.ts
var t = e("admin-ai-generations", {
	list: (e, t) => [
		"list",
		e,
		t
	],
	summary: (e) => ["summary", e]
});
//#endregion
export { t as adminAiGenerationQueryKeys };
